import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import useStyles from '@screens/Success/SuccessScreen.styles'
import { ContactFormFields } from '@customTypes/ContactFormFields'
import { ReactComponent as CloseIcon } from 'src/images/icon-close-v2.svg'
import Page from '@components/Page'
import { useCloseAvailyContext } from '@context/CloseAvailyContext'
import { BOOKING_SUCCESS_URL } from 'src/config/imageUrls'
import { getImageUrl } from 'src/utils/getImageUrl'

type BookingReceivedProps = {
  contactDetails?: Partial<ContactFormFields>
  asModal?: boolean
}

const BookingReceivedScreen = ({ contactDetails, asModal }: BookingReceivedProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const closeAvaily = useCloseAvailyContext()

  const body = (
    <>
      <div className={classes.closeIcon}>{asModal && closeAvaily && <CloseIcon onClick={() => closeAvaily()} />}</div>
      <div className={classes.root}>
        <div className={classes.info}>
          <div className={classes.headerText}>
            <h1 className={classes.h1}>
              <Trans
                i18nKey="non-confirmed_booking_message_title"
                values={{
                  firstName: contactDetails?.firstName,
                  lastName: contactDetails?.lastName,
                }}
              />
            </h1>
            <p className={classes.description}>{t('non-confirmed_booking_message_description')}</p>
          </div>
          <img className={classes.successImage} src={getImageUrl({ src: BOOKING_SUCCESS_URL })} alt="toothbrushes" />
        </div>
      </div>
    </>
  )
  return <Page header={undefined} body={body} footer={undefined} />
}

export default BookingReceivedScreen
